import React, { useState } from "react";
import {
  LOGIN_URL,
  SEND_OTP_URL,
  OTP_AUTH_URL,
  CLIENT_OTP_URL,
  VERIFY_OTP,
  RESET_PASSWORD,
  FORGET_USERNAME_URL,
} from "../services/Apis";
import { encStorage } from "../hooks/encStorage";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [success, setSucess] = useState("");
  const [useOtp, setUseOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [forgetPass, setforgetPass] = useState(false);
  const [forgetUsername, setForgetUsername] = useState(false);
  const [timer, setTimer] = useState(0);
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState("");
  const [otpVerified, setOtpVerified] = useState("");
  const [phone, setPhone] = useState("");

  const navigate = useNavigate();
  const handleVerifyOtp = async () => {
    try {
      const response = await axios.post(VERIFY_OTP, { email, otp });
      setOtpVerified(true);
    } catch (err) {
      setError("Failed to verify OTP. Please try again.");
    }
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        useOtp ? OTP_AUTH_URL : LOGIN_URL,
        useOtp ? { email, otp } : { email, password }
      );
      encStorage.setItem("token", response.data.token);
      encStorage.setItem("client_code", response.data.client_code);
      encStorage.setItem("userType", response.data.userType);
      encStorage.setItem("client_id", response.data.client_id);
      encStorage.setItem("id", response.data.id);
      encStorage.setItem("name", response.data.name);
      navigate("/dashboard");
    } catch (err) {
      setError("Login failed. Please check your credentials and try again.");
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(RESET_PASSWORD, { email, newPassword });
      setSucess(
        "Password reset successful. Please login with your new password."
      );
      navigate("/login");
      setforgetPass(false);
    } catch (err) {
      setError("Failed to reset password. Please try again.");
    }
  };

  const handleSendOtp = async () => {
    try {
      const token = encStorage.getItem("token");
      await axios.post(SEND_OTP_URL, { email });
      setOtpSent(true);
      setTimer(30);
      const countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(countdown);
            setOtpSent(false);
          }
          return prev - 1;
        });
      }, 1000);
    } catch (err) {
      setError("Failed to send OTP. Please try again.");
    }
  };

  const handleForgetUsername = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(FORGET_USERNAME_URL, { phone });
      if (response.data.success) {
        setSucess("Login Credentials sent to registered Phone No.");
      } else {
        setError("Phone No does not exist, please check again.");
      }
      setForgetUsername(false);
    } catch (err) {
      setError("Phone No does not exist, please check again.");
    }
  };

  const forgetPassword = () => {
    setforgetPass(forgetPass == false ? true : false);
  };

  const forgetUsernameToggle = () => {
    setForgetUsername(forgetUsername == false ? true : false);
  };

  const toggleLoginMethod = () => {
    setUseOtp(!useOtp);
    setOtpSent(false);
    setTimer(0);
  };

  return (
    <>
      <div className="container-fluid login-container">
        <div className="row">
          <div className="col-md-6 d-none d-md-block col-h-100 login-image overflow-hidden p-0">
            <img src={"/images/ai.jpeg"} alt="ai" className="col-h-100" />
          </div>
          {forgetPass == false && forgetUsername == false ? (
            <div className="col-md-6">
              <div className="login-form w-100">
                <div className="text-center mb-5 mt-4 text-primary fs-1 text-center">
                  <img src="/images/logo.png" alt="logo" className="w-50" />
                </div>
              </div>
              {error && <div className="alert alert-danger">{error}</div>}
              {success && <div className="alert alert-success">{success}</div>}
              <form
                className="form w-100 ps-5 pe-5"
                noValidate
                id="login-form"
                onSubmit={handleLogin}
              >
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email/Username
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {!useOtp && (
                  <div id="passwordLogin">
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i
                            className={`fa ${
                              showPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {useOtp && (
                  <div id="otpLogin">
                    {!otpSent && (
                      <button
                        type="button"
                        className="btn btn-secondary w-100 mb-3"
                        onClick={handleSendOtp}
                        disabled={!email}
                      >
                        Send OTP
                      </button>
                    )}
                    {otpSent && (
                      <div className="mb-3">
                        <label htmlFor="otp" className="form-label">
                          OTP
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="otp"
                          name="otp"
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                        />
                        <small className="form-text text-muted">
                          You can resend OTP in {timer} seconds.
                        </small>
                      </div>
                    )}
                  </div>
                )}
                {!useOtp || otpSent ? (
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    id="loginButton"
                  >
                    Login
                  </button>
                ) : null}
              </form>
              <div className="text-center">
                <p className="text-primary mt-1 mb-2">Or</p>
              </div>
              <div className="text-center">
                <button
                  className="btn btn-secondary"
                  onClick={toggleLoginMethod}
                >
                  {useOtp ? "Use Password Instead" : "Use OTP Instead"}
                </button>
              </div>
              <div className="text-center mt-2">
                <p>
                  <Link onClick={forgetPassword}>Forget Password</Link>
                </p>
                <p>
                  <Link onClick={forgetUsernameToggle}>Forget Username</Link>
                </p>
              </div>
            </div>
          ) : forgetPass ? (
            <div className="col-md-6 d-flex align-items-center">
              <div className="login-form w-100">
                <div className="text-center mb-5 mt-4 text-primary fs-1 text-center">
                  <img src="/images/logo.png" alt="logo" className="w-50" />
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                <form
                  className="form w-100"
                  noValidate
                  id="reset-form"
                  onSubmit={handleReset}
                >
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email/Username
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="name@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  {!otpSent && (
                    <button
                      type="button"
                      className="btn btn-secondary w-100 mb-3"
                      onClick={handleSendOtp}
                      disabled={!email}
                    >
                      Send OTP
                    </button>
                  )}
                  {otpSent && (
                    <>
                      <div className="mb-3">
                        <label htmlFor="otp" className="form-label">
                          OTP
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="otp"
                          name="otp"
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          disabled={otpVerified}
                        />
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary w-100 mb-3"
                        onClick={handleVerifyOtp}
                      >
                        Verify OTP
                      </button>
                    </>
                  )}
                  {otpVerified && (
                    <>
                      <div className="mb-3">
                        <label htmlFor="newPassword" className="form-label">
                          New Password
                        </label>
                        <div className="input-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            id="newPassword"
                            name="newPassword"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <i
                              className={`fa ${
                                showPassword ? "fa-eye-slash" : "fa-eye"
                              }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                      <button type="submit" className="btn btn-primary w-100">
                        Reset Password
                      </button>
                    </>
                  )}
                </form>
                <div className="text-center mt-2">
                  <p>
                    <Link onClick={forgetPassword}>Login</Link>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="col-md-6 d-flex align-items-center">
              <div className="login-form w-100">
                <div className="text-center mb-5 mt-4 text-primary fs-1 text-center">
                  <img src="/images/logo.png" alt="logo" className="w-50" />
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                {success && (
                  <div className="alert alert-success">{success}</div>
                )}
                <form
                  className="form w-100"
                  noValidate
                  id="forget-username-form"
                  onSubmit={handleForgetUsername}
                >
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">
                      Phone Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phone"
                      name="phone"
                      placeholder="Enter your phone number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    Retrieve Username
                  </button>
                </form>
                <div className="text-center mt-2">
                  <p>
                    <Link onClick={forgetUsernameToggle}>Login</Link>
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Login;
